const age = [...Array(65 + 1).keys()].slice(18)

const job = [...Array(10 + 1).keys()]

const prefecturesWhich =
  [
    {
      key: null,
      label: '現住所か希望勤務地いずれか合致'
    },
    {
      key: 'present',
      label: '現住所のみ'
    },
    {
      key: 'desired',
      label: '希望勤務地のみ'
    }
  ]

const occupationOperators =
  [
    {
      key: 'or',
      label: '経験職種か希望職種いずれか合致'
    },
    {
      key: 'and',
      label: '経験職種か希望職種すべて合致(and検索)'
    }
  ]

const businessOperators =
  [
    {
      key: 'or',
      label: '経験業種か希望業種いずれか合致'
    },
    {
      key: 'and',
      label: '経験業種か希望業種すべて合致(and検索)'
    }
  ]

const behaviors = [
  {
    value: 1,
    label: 'すべての会員（行動ターゲティングを指定しない）'
  },
  {
    value: 2,
    label: 'この求人と同じ職種大分類の求人を閲覧している会員'
  },
  {
    value: 3,
    label: 'この求人と同じ職種小分類(職種コード)の求人を閲覧している会員'
  },
  {
    value: 4,
    label: 'この求人を閲覧している会員'
  },
  {
    value: 5,
    label: 'この求人を検討中リストに保存している会員'
  }
]

const excludeEntryOtherCompanyJob = [
  {
    key: 'excludeEntryOtherCompanyJob',
    label: '他社の求人へ選考応募済みの会員を含めない'
  },
  {
    key: 'excludeCasualInterviewEntryOtherCompanyJob',
    label: '他社の求人へ話を聞きたい応募済みの会員を含めない'
  }
]

const scoutResultSort =
  [
    {
      id: 0,
      name: '最終ログインが新しい順',
      keys: ['member.recentActionDate'],
      order: 'desc'
    },
    {
      id: 1,
      name: '会員登録日が新しい順',
      keys: ['member.insertDate'],
      order: 'desc',
      secondKeys: ['member.recentActionDate', 'member.updateDate'],
      secondOrder: 'desc'
    },
    {
      id: 2,
      name: '年齢が低い順',
      keys: ['member.birthdate'],
      order: 'desc',
      secondKeys: ['member.recentActionDate', 'member.updateDate'],
      secondOrder: 'desc'
    },
    {
      id: 3,
      name: '年齢が高い順',
      keys: ['member.birthdate'],
      order: 'asc',
      secondKeys: ['member.recentActionDate', 'member.updateDate'],
      secondOrder: 'desc'
    },
    {
      id: 4,
      name: '他社からのスカウトが少ない順',
      keys: ['member.approachedCount'],
      order: 'asc',
      secondKeys: ['member.recentActionDate', 'member.updateDate'],
      secondOrder: 'desc'
    },
    {
      id: 5,
      name: '卒業年月が新しい順',
      keys: ['member.graduatedSchool.yearMonth'],
      order: 'desc',
      secondKeys: ['member.recentActionDate', 'member.updateDate'],
      secondOrder: 'desc'
    }
  ]
const scoutResultSortScouted =
  [
    {
      id: 0,
      name: '送信日時が新しい順',
      keys: ['member.scout.latestMessage.insertDate'],
      order: 'desc',
      secondKeys: ['member.recentActionDate', 'member.updateDate'],
      secondOrder: 'desc'
    },
    {
      id: 1,
      name: '送信日時が古い順',
      keys: ['member.scout.latestMessage.insertDate'],
      order: 'asc',
      secondKeys: ['member.recentActionDate', 'member.updateDate'],
      secondOrder: 'desc'
    },
    {
      id: 2,
      name: '送信回数が少ない順',
      keys: ['member.scout.messagesCount'],
      order: 'asc',
      secondKeys: ['member.recentActionDate', 'member.updateDate'],
      secondOrder: 'desc'
    },
    {
      id: 3,
      name: '送信回数が多い順',
      keys: ['member.scout.messagesCount'],
      order: 'desc',
      secondKeys: ['member.recentActionDate', 'member.updateDate'],
      secondOrder: 'desc'
    },
    {
      id: 4,
      name: '最終ログインが新しい順',
      keys: ['member.recentActionDate', 'member.updateDate'],
      order: 'desc'
    },
    {
      id: 5,
      name: '年齢が低い順',
      keys: ['member.birthdate'],
      order: 'desc',
      secondKeys: ['member.recentActionDate', 'member.updateDate'],
      secondOrder: 'desc'
    },
    {
      id: 6,
      name: '年齢が高い順',
      keys: ['member.birthdate'],
      order: 'asc',
      secondKeys: ['member.recentActionDate', 'member.updateDate'],
      secondOrder: 'desc'
    },
    {
      id: 7,
      name: '他社からのスカウトが少ない順',
      keys: ['member.approachedCount'],
      order: 'asc',
      secondKeys: ['member.recentActionDate', 'member.updateDate'],
      secondOrder: 'desc'
    }
  ]
const scoutResultSortLiked =
  [
    {
      id: 0,
      name: '送信日時が新しい順',
      keys: ['member.likedDate'],
      order: 'desc',
      secondKeys: ['member.recentActionDate', 'member.updateDate'],
      secondOrder: 'desc'
    },
    {
      id: 1,
      name: '送信日時が古い順',
      keys: ['member.likedDate'],
      order: 'asc',
      secondKeys: ['member.recentActionDate', 'member.updateDate'],
      secondOrder: 'desc'
    },
    {
      id: 2,
      name: '最終ログインが新しい順',
      keys: ['member.recentActionDate', 'member.updateDate'],
      order: 'desc'
    },
    {
      id: 3,
      name: '年齢が低い順',
      keys: ['member.birthdate'],
      order: 'desc',
      secondKeys: ['member.recentActionDate', 'member.updateDate'],
      secondOrder: 'desc'
    },
    {
      id: 4,
      name: '年齢が高い順',
      keys: ['member.birthdate'],
      order: 'asc',
      secondKeys: ['member.recentActionDate', 'member.updateDate'],
      secondOrder: 'desc'
    },
    {
      id: 5,
      name: '他社からのスカウトが少ない順',
      keys: ['member.approachedCount'],
      order: 'asc',
      secondKeys: ['member.recentActionDate', 'member.updateDate'],
      secondOrder: 'desc'
    }
  ]
const scoutRecommendedSort =
  [
    {
      id: 0,
      name: 'おすすめ順',
      keys: ['member.priority'],
      order: 'asc',
      secondKeys: ['member.recentActionDate', 'member.updateDate'],
      secondOrder: 'desc'
    },
    {
      id: 1,
      name: '最終ログインが新しい順',
      keys: ['member.recentActionDate', 'member.updateDate'],
      order: 'desc'
    },
    {
      id: 2,
      name: '会員登録日が新しい順',
      keys: ['member.insertDate'],
      order: 'desc',
      secondKeys: ['member.recentActionDate', 'member.updateDate'],
      secondOrder: 'desc'
    },
    {
      id: 3,
      name: '年齢が低い順',
      keys: ['member.birthdate'],
      order: 'desc',
      secondKeys: ['member.recentActionDate', 'member.updateDate'],
      secondOrder: 'desc'
    },
    {
      id: 4,
      name: '年齢が高い順',
      keys: ['member.birthdate'],
      order: 'asc',
      secondKeys: ['member.recentActionDate', 'member.updateDate'],
      secondOrder: 'desc'
    },
    {
      id: 5,
      name: '他社からのスカウトが少ない順',
      keys: ['member.approachedCount'],
      order: 'asc',
      secondKeys: ['member.recentActionDate', 'member.updateDate'],
      secondOrder: 'desc'
    },
    {
      id: 6,
      name: '卒業年月が新しい順',
      keys: ['member.graduatedSchool.yearMonth'],
      order: 'desc',
      secondKeys: ['member.recentActionDate', 'member.updateDate'],
      secondOrder: 'desc'
    }
  ]
const scoutResultSortExcluded =
  [
    {
      id: 0,
      name: '除外した日時が新しい順',
      keys: ['member.excludedInsertDate'],
      order: 'desc',
      secondKeys: ['member.recentActionDate', 'member.updateDate'],
      secondOrder: 'desc'
    },
    {
      id: 1,
      name: '最終ログインが新しい順',
      keys: ['member.recentActionDate', 'member.updateDate'],
      order: 'desc'
    },
    {
      id: 2,
      name: '会員登録日が新しい順',
      keys: ['member.insertDate'],
      order: 'desc',
      secondKeys: ['member.recentActionDate', 'member.updateDate'],
      secondOrder: 'desc'
    },
    {
      id: 3,
      name: '年齢が低い順',
      keys: ['member.birthdate'],
      order: 'desc',
      secondKeys: ['member.recentActionDate', 'member.updateDate'],
      secondOrder: 'desc'
    },
    {
      id: 4,
      name: '年齢が高い順',
      keys: ['member.birthdate'],
      order: 'asc',
      secondKeys: ['member.recentActionDate', 'member.updateDate'],
      secondOrder: 'desc'
    },
    {
      id: 5,
      name: '他社からのスカウトが少ない順',
      keys: ['member.approachedCount'],
      order: 'asc',
      secondKeys: ['member.recentActionDate', 'member.updateDate'],
      secondOrder: 'desc'
    },
    {
      id: 6,
      name: '卒業年月が新しい順',
      keys: ['member.graduatedSchool.yearMonth'],
      order: 'desc',
      secondKeys: ['member.recentActionDate', 'member.updateDate'],
      secondOrder: 'desc'
    }
  ]
const applicantResultSort =
  [
    {
      id: 0,
      name: 'やりとりが新しい順',
      keys: ['applicant.message.sendReceiveDateTime'],
      order: 'desc',
      secondKeys: ['applicant.entryDate'],
      secondOrder: 'desc'
    },
    {
      id: 1,
      name: 'やりとりが古い順',
      keys: ['applicant.message.sendReceiveDateTime', 'applicant.entryDate'],
      order: 'asc'
    },
    {
      id: 2,
      name: '応募日時が新しい順',
      keys: ['applicant.entryDate'],
      order: 'desc'
    },
    {
      id: 3,
      name: '応募日時が古い順',
      keys: ['applicant.entryDate'],
      order: 'asc'
    },
    {
      id: 4,
      name: '評価が高い順',
      keys: ['applicant.currentSelection.evaluation.id'],
      order: 'asc'
    },
    {
      id: 5,
      name: '年齢が低い順',
      keys: ['applicant.user.birthday'],
      order: 'desc'
    },
    {
      id: 6,
      name: '年齢が高い順',
      keys: ['applicant.user.birthday'],
      order: 'asc'
    },
    {
      id: 7,
      name: '選考ステータス順',
      keys: ['applicant.currentSelection.statusOrder'],
      order: 'asc'
    }
  ]
const bulkRegister = [
  {
    id: 1,
    name: '送信候補へ',
    routeNameKeys: ['scoutSearchResult', 'dashboardTop', 'scoutTop', 'scoutRecommended'],
    isPublishedCheck: false,
    limit: 1000,
    tooltip: '送信候補への振り分けは1回あたり1,000件以内です。'
  },
  {
    id: 2,
    name: '除外者へ',
    routeNameKeys: ['scoutSearchResult', 'scoutUnderReview'],
    isPublishedCheck: false,
    limit: 1000,
    tooltip: '除外者への振り分けは1回あたり1,000件以内です。'
  },
  {
    id: 3,
    name: '検索対象に戻す',
    routeNameKeys: ['scoutUnderReview', 'scoutExcluded'],
    isPublishedCheck: false,
    limit: 1000,
    tooltip: '検索対象へ戻すのは1回あたり1,000件以内です。'
  },
  {
    id: 4,
    name: 'スカウト',
    routeNameKeys: ['scoutSearchResult', 'scoutUnderReview', 'scoutLiked', 'dashboardTop', 'scoutTop', 'scoutRecommended'],
    isPublishedCheck: true,
    isPermission: true,
    limit: 2000,
    tooltip: 'スカウトは1回あたり2,000件以内です。'
  },
  {
    id: 5,
    name: 'スカウト',
    routeNameKeys: ['scoutScouted'],
    isPublishedCheck: true,
    isPermission: true,
    isResend: true,
    limit: 2000,
    tooltip: 'スカウトは1回あたり2,000件以内です。'
  },
  {
    id: 6,
    name: 'いいね',
    routeNameKeys: ['scoutSearchResult', 'scoutUnderReview', 'dashboardTop', 'scoutTop', 'scoutRecommended', 'scoutScouted'],
    isPublishedCheck: true,
    isPermission: true,
    limit: 1000,
    tooltip: 'いいね送信は1回あたり1,000件以内です。'
  },
  {
    id: 7,
    name: '現在の掲載期間の送信候補にコピー',
    routeNameKeys: ['scoutUnderReview', 'scoutScouted'],
    isPublishedCheck: false,
    showCopy: true,
    limit: 1000,
    tooltip: '送信候補への振り分けは1回あたり1,000件以内です。'
  }
]

const searchSkillExperienceRange = [
  {
    id: '0',
    name: '年数不問'
  },
  {
    id: '1',
    name: '1年以上'
  },
  {
    id: '3',
    name: '3年以上'
  }
]

const searchOccupationExperienceRange = [
  {
    id: null,
    name: '年数不問'
  },
  {
    id: '0',
    name: '1ヶ月以上'
  },
  {
    id: '1',
    name: '1年以上'
  },
  {
    id: '3',
    name: '3年以上'
  },
  {
    id: '5',
    name: '5年以上'
  },
  {
    id: '10',
    name: '10年以上'
  }
]

const readingStatus = [
  {
    id: 1,
    name: '既読'
  },
  {
    id: 2,
    name: '未読'
  }
]

const approachedOtherCompany = [
  {
    id: 1,
    name: '10社以内',
    value: '10'
  },
  {
    id: 2,
    name: '30社以内',
    value: '30'
  },
  {
    id: 3,
    name: '49社以内',
    value: '49'
  }
]

const applicantBulkUpdate = [
  {
    key: 'pdf_download',
    name: '一括PDFダウンロード',
    optionLabel: '選択した応募者を一括PDFダウンロード',
    permission: 'canPdfDownload',
    inputType: ''
  },
  {
    key: 'csv_download',
    name: '一括CSVダウンロード',
    optionLabel: '選択した応募者を一括CSVダウンロード',
    inputType: ''
  },
  {
    key: 'responsible_staffs',
    name: '人事担当',
    optionLabel: '選択した応募者の人事担当を更新',
    inputType: 'select'
  },
  {
    key: 'phases',
    name: '選考フェーズ',
    optionLabel: '選択した応募者の選考フェーズを更新',
    inputType: 'select'
  },
  {
    key: 'phase_statuses',
    name: '選考ステータス',
    optionLabel: '選択した応募者の選考ステータスを更新',
    inputType: 'select',
    isCartInAnimation: true
  },
  {
    key: 'remarks',
    name: '備考',
    optionLabel: '選択した応募者の備考を更新',
    inputType: 'textarea'
  },
  {
    key: 'create_bulk_message',
    name: 'メッセージ一括送信',
    optionLabel: '選択した応募者へメッセージを一括送信',
    permission: 'canSendMessage',
    inputType: ''
  }
]

const messageResponseStatus = [
  {
    id: 1,
    name: '未読',
    status: { isRead: false }
  },
  {
    id: 2,
    name: '未返信',
    status: { isReplied: false }
  },
  {
    id: 3,
    name: '返信済み',
    status: { isReplied: true }
  }
]

const employed =
  [
    {
      value: false,
      name: '離職中'
    },
    {
      value: true,
      name: '在職中'
    }
  ]

// スカウトテストでこけるため経験年数の定義を別途定義 スカウトの経験年数のidも数値に変わった時に統一化
const applicantOccupationExperienceRange = [
  {
    id: '0',
    name: '年数不問'
  },
  {
    id: '1',
    name: '1年以上'
  },
  {
    id: '3',
    name: '3年以上'
  },
  {
    id: '5',
    name: '5年以上'
  },
  {
    id: '10',
    name: '10年以上'
  }
]

const hasSpecialFavorsOrNot = [
  {
    id: 1,
    name: '有効のみ'
  },
  {
    id: 2,
    name: '有効・無効'
  },
  {
    id: 3,
    name: '特典なし'
  }
]

const defaultApplicantDisplayItems = [
  {
    name: '応募日'
  },
  {
    name: '応募者'
  },
  {
    name: '求人'
  },
  {
    name: 'アプローチ状況'
  },
  {
    name: 'メッセージ'
  }
]

const durationTimeMinutes = [30, 60, 90, 120]

// 面接情報系の定数
const interviewer = {
  checkpointReasonLabels: [
    {
      id: 1,
      prefixName: '見ているポイント',
      suffixName: 'の理由'
    },
    {
      id: 2,
      prefixName: '不採用になる方の傾向・NGワード',
      suffixName: 'の意図・理由'
    },
    {
      id: 3,
      prefixName: '質問',
      suffixName: 'の意図・理由'
    }
  ]
}

// 応募自動返信設定定数
const applicantAutoReplyOptions = {
  whetherToUses: [
    {
      value: false,
      label: '利用しない'
    },
    {
      value: true,
      label: '利用する'
    }
  ],
  allReplies: [
    {
      value: false,
      label: '全応募者'
    },
    {
      value: true,
      label: 'スカウト応募者を除く',
      note: '(応募した求人とは、別の求人でスカウトした方も除外となります）'
    }
  ],
  sendSchedulingTimes: [
    {
      value: false,
      label: '応募完了後に即時送信する'
    },
    {
      value: true,
      label: '設定時刻に送信する'
    }
  ]
}

const directTypeLabel = {
  69: 'Direct type',
  70: 'Direct typeスカウト',
  78: 'Direct type面接確約スカウト'
}

const directTypeLabelContainLF = {
  70: 'Direct typeスカウト',
  78: 'Direct type\n面接確約スカウト'
}

const entryMessageReservationCancelReason = [
  {
    id: 1,
    name: '返信済み',
    label: '応募者からメッセージを受信したため、送信予約がキャンセルされました。'
  },
  {
    id: 2,
    name: '退会済み',
    label: '応募者が退会したため、送信予約がキャンセルされました。'
  }
]

export {
  age,
  job,
  prefecturesWhich,
  occupationOperators,
  businessOperators,
  behaviors,
  excludeEntryOtherCompanyJob,
  scoutResultSort,
  scoutResultSortScouted,
  scoutResultSortLiked,
  scoutRecommendedSort,
  scoutResultSortExcluded,
  applicantResultSort,
  bulkRegister,
  searchSkillExperienceRange,
  searchOccupationExperienceRange,
  readingStatus,
  approachedOtherCompany,
  applicantBulkUpdate,
  messageResponseStatus,
  employed,
  applicantOccupationExperienceRange,
  hasSpecialFavorsOrNot,
  durationTimeMinutes,
  defaultApplicantDisplayItems,
  interviewer,
  applicantAutoReplyOptions,
  directTypeLabel,
  directTypeLabelContainLF,
  entryMessageReservationCancelReason
}
